import { LocationData } from '../@types/common.types';
import { env } from '../config/env';

export const getUserLocationData = async (): Promise<LocationData | null> => {
    try {
        const res = await fetch(
            `${env.ipInfo.liteUrl}/me/?token=${env.ipInfo.token}`
        );
        if (!res.ok) return null;
        const data = (await res.json()) as LocationData;
        return data;
    } catch {
        return null;
    }
};
